import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Vote, VoteService} from "../../service/vote.service";


@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AnalyticsComponent implements OnInit {

  votes: Vote[];

  constructor(private voteService: VoteService) {

    this.votes = [
      new Vote(),
      new Vote(),
      new Vote()
    ];

  }

  ngOnInit() {
    this.getVotes();
  }

  public getVotes():void {

    this.voteService.getVotes().then(
        votes => {
          this.votes = votes;
        }
    )
  }
}




// WEBPACK FOOTER //
// ./src/app/analytics/analytics/analytics.component.ts